import * as React from 'react';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Dispatch, connect } from 'react-redux';
import { IReportState, IApplicationState, AppActionCreators, ReportActionCreators, IPreSelectHistoryResponse, IPreSelectHistoryDetailsResponse } from '@nkr/store/index';
import { IPreSelectHistory, IPreSelectHistoryDetails } from '@nkr/models/index';
import { ColumnApi, CsvExportParams, GridApi, GridReadyEvent, ProcessCellForExportParams } from 'ag-grid-community';
import { HeaderWrapper } from './styles';
import { Button, FormControl, Label } from 'react-bootstrap';
import PreSelectHistoryByCenterReportGrid from './pre-select-history-grid';
import CenterDetails from './center-details-modal';

interface IOwnProps {
    centerId: number,
    isAdmin: boolean
}

interface IStateProps {
    reports: IReportState
}

interface IDispatchProps {
    onShowLoading: (message?: string) => Promise<void>,
    onHideLoading: () => void,
    getPreselectHistoryReport: (reportDate: string) => Promise<IPreSelectHistoryResponse>,
    getPreselectHistoryDetailsReport: (centerId: number, startDate: string, endDate: string) => Promise<IPreSelectHistoryDetailsResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps

interface IState {
    centerId: number,
    reportDate: string,
    report: IPreSelectHistory[],
    reportDetails: {
        list: IPreSelectHistoryDetails[],
        average: number
    },
    showModal: boolean,
    gridApi: GridApi,
    columnApi: ColumnApi,
}

class PreSelectHistoryByCenterReport extends React.Component<TProps, IState> {
    readonly state: IState = {
        centerId: 0,
        reportDate: moment().startOf('month').add(-1, 'months').format('YYYY-MM-DD'),
        report: [],
        reportDetails: {
            list: [],
            average: 0
        },
        showModal: false,
        gridApi: null,
        columnApi: null,
    }

    onGridReady = (e: GridReadyEvent) => {
        this.setState({
            gridApi: e.api,
            columnApi: e.columnApi
        });
    }

    componentDidMount = () => {
        this.getData(this.state.reportDate);
    }

    getData = (reportDate: string) => {
        this.props.onShowLoading('Getting report data, one moment please...').then(() => {
            this.props.getPreselectHistoryReport(reportDate)
                .then((response: IPreSelectHistoryResponse) => {
                    this.setState({
                        report: response.data.results
                    });
                })
                .catch((ex) => {
                    alert('An error occured while loading report data');

                })
                .finally(() => {
                    this.props.onHideLoading();
                });
        });
    }

    handleReset = () => {
        let reportDate = moment(this.state.reportDate).format('YYYY-MM-DD')
        this.getData(reportDate);
    }

    handleDateChange = (reportDate: string) => {
        this.setState({
            reportDate
        }, () => {
            this.getData(reportDate);
        });
    }

    handleCancel = () => {
        this.setState({
            showModal: false
        });
    }

    handlePreselectHistoryDetails = (centerId: number) => {
        let startDate = this.state.reportDate;
        let endDate = moment(startDate).endOf('month').format('YYYY-MM-DD');

        this.props.onShowLoading('Getting Preselect History Details, one moment please...').then(() => {
            this.props.getPreselectHistoryDetailsReport(centerId, startDate, endDate)
                .then(response => {
                    if (response.data.success) {
                        this.setState({
                            showModal: true,
                            centerId: centerId,
                            reportDetails: response.data.results
                        });
                    }
                })
                .finally(() => {
                    this.props.onHideLoading();
                });
        });
    }

    getRange = () => {
        let startDate = moment().startOf('month').add(-15, 'months');
        let endDate = moment().add(1, 'month');

        let fromDate = startDate.clone();
        let toDate = endDate.clone();
        let diff = toDate.diff(fromDate, 'month');
        let range = [];

        for (let i = 0; i < diff; i++) {
            range.push(moment(startDate).add(i, 'month'))
        }

        range.reverse();

        return range;
    }

    getHistoryAverage = (data: IPreSelectHistory[]): any => {
        let sumPreselectsAvg = _.sumBy(data, item => item.adjustedComplianceAverage);
        let totalPreselects = data.length;
        let avgtotalPreselects = _.round(totalPreselects > 0 ? (sumPreselectsAvg / totalPreselects) : 0, 1);

        return {
            grandpreSelectPerc: avgtotalPreselects
        };
    }

    handleExport = () => {
        let params: CsvExportParams = {
            columnGroups: true,
            fileName: 'preselect-history.csv',
            processCellCallback: (params: ProcessCellForExportParams) => {
                let colDef = params.column.getColDef();

                if (colDef.headerName == 'Rank')
                    return params.node.rowIndex + 1;
                else if (colDef.colId == 'xpDate')
                    return moment(params.value).format('MM/DD/YYYY');

                return params.value;
            }
        };

        this.state.gridApi.exportDataAsCsv(params);
    }

    render = () => {
        const dateRange = this.getRange();
        const labeldate = moment(this.state.reportDate).format('MM/YYYY');
        const startDate = moment(this.state.reportDate).startOf('month').format('MM/DD/YYYY');
        const endDate = moment(this.state.reportDate).endOf('month').format('MM/DD/YYYY');
        const totalshistory = this.getHistoryAverage(this.state.report);

        return (
            <>
                {this.props.isAdmin && (
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                        <div style={{ fontSize: 28, fontWeight: 500 }}>Preselect History by Center</div>
                        <div>
                        </div>
                    </div>
                )}

                <HeaderWrapper>
                    <div className='well well-sm' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '50%' }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div>Month/Year:&nbsp;&nbsp;</div>
                            <FormControl
                                componentClass='select'
                                value={this.state.reportDate}
                                onChange={(e: React.FormEvent<FormControl & HTMLSelectElement>) => this.handleDateChange(e.currentTarget.value)}
                            >
                                {dateRange.map(date =>
                                    <option value={date.format('YYYY-MM-DD')}>{date.format('MM/YYYY')}</option>
                                )}
                            </FormControl>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Label bsStyle='info' style={{ fontSize: '100%' }}>The average preselect rate for {labeldate} was {totalshistory.grandpreSelectPerc}%.</Label>
                        </div>

                        <div>
                            <Button onClick={this.handleExport}>Export CSV</Button>
                        </div>
                    </div>
                </HeaderWrapper>

                <PreSelectHistoryByCenterReportGrid
                    isAdmin={this.props.isAdmin}
                    report={this.state.report}
                    onGridReady={this.onGridReady}
                    onPreselectHistoryDetails={this.handlePreselectHistoryDetails}
                />

                <CenterDetails
                    show={this.state.showModal}
                    startDate={startDate}
                    endDate={endDate}
                    reportDetails={this.state.reportDetails.list}
                    average={this.state.reportDetails.average}
                    onClose={this.handleCancel}
                />
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        reports: appState.reports
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        onShowLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        onHideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getPreselectHistoryReport: (reportDate) => {
            return dispatch(ReportActionCreators.getPreselectHistoryReport(reportDate));
        },
        getPreselectHistoryDetailsReport: (centerId, startDate, endDate) => {
            return dispatch(ReportActionCreators.getPreselectHistoryDetailsReport(centerId, startDate, endDate));
        }
    }
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(PreSelectHistoryByCenterReport);